import { Dialog, LoadingManager } from '@common/overlay-manager';

import { addCartItemList } from '../graphql/select-option.2';
import { AddCartItemListInput } from '../graphql/select-option_types.2';
import { handleNetworkError } from './handle_network_error';
import { redirectInquiries } from './redirectInquiries';

type Props = {
  catalog_product_id?: string;
} & AddCartItemListInput;

export const addCart = async (
  props: Props,
  callback?: <T>(result: T) => void,
  errorCallback?: (error: any) => void,
) => {
  const { catalog_product_id, ...input } = props;
  try {
    LoadingManager.open({ isMiniLoader: true });
    const result = await addCartItemList({ input }, { show_alert: false });

    if (result.data && result.data.addCartItemList && callback) {
      callback(result);
    } else if (errorCallback) {
      // data가 없는 경우도 에러로 처리 (GraphQL 에러 케이스)
      errorCallback({ message: 'addCartItemList returned falsy data' });
    }
  } catch (e: any) {
    // 에러 콜백 호출
    if (errorCallback) {
      return errorCallback(e);
    }

    const is_network_error = await handleNetworkError(e, async () => await addCart(props, callback));

    if (!is_network_error) {
      await Dialog.alert(e?.description || '장바구니 담기 실패하였습니다.');
    }
    if (e.extensions?.code === 'seller_blocked_user' && catalog_product_id) {
      redirectInquiries(catalog_product_id);
    }
  } finally {
    LoadingManager.close();
  }
};
